import AXIOS from "./axios";

export class Verification {
  static sendPhoneCode() {
    return AXIOS.post("/phone_verifications");
  }

  static verifyPhoneCode(code) {
    return AXIOS.post("/phone_verifications/verify", { code });
  }

  static resendEmailConfirmation() {
    return AXIOS.post("/email_confirmations/resend");
  }
}
